import { useContext } from 'react';
import { logError } from '@/utils/logHandling';
import { AudioContext } from '@/contexts/AudioContext';
import { AudioContextValue } from '@/contexts/AudioContext/types';

export const useAudioContext = (): AudioContextValue => {
  const consumedContext = useContext(AudioContext);

  if (!consumedContext) {
    logError('AudioContext not found error');
    throw new Error('AudioContext not found');
  }

  const {
    init,
    loadAndPlaySound,
    pauseSound,
    stopSound,
    unloadSound,
    changeAudioPosition,
    moveBack,
    context,
    resetContext,
  } = consumedContext;

  return {
    init,
    loadAndPlaySound,
    pauseSound,
    stopSound,
    unloadSound,
    changeAudioPosition,
    moveBack,
    context,
    resetContext,
  };
};
